import * as React from "react";
import { DialogContent, Grid, IconButton, MenuItem } from "@mui/material";
import {
    Dialog,
    DialogTitle,
    DialogActions,
    Checkbox,
    FormControlLabel,
    TextField,
    Radio,
} from "@mui/material";
import {
    addTransaction,
    getAllUnits,
    getContractByProperty,
    getReceiptPdc,
    updateTransaction,
} from "state/apis";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { useTheme } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import { Close as CloseIcon } from "@mui/icons-material";

const AddReceipt = ({ open, onClose, onSubmit, editData, editMode, property, canEditDate = false }) => {
    const theme = useTheme();
    const [data, setData] = React.useState([]);
    const [contractData, setContractData] = React.useState([]);
    const [cashChecked, setCashChecked] = React.useState(false);
    const [chequeChecked, setChequeChecked] = React.useState(false);
    const [bankTransferChecked, setBankTransferChecked] = React.useState(false);
    const [otherIncomeChecked, setOtherIncomeChecked] = React.useState(false);
    const [deposit, setDeposit] = React.useState(false);
    const [rent, setRent] = React.useState(true);
    const [selectedPdcId, setSelectedPdcId] = React.useState(null);
    const [selectedPdcData, setSelectedPdcData] = React.useState(null);
    const [units, setFlat] = React.useState([]);
    const [pdcType, setPdcType] = React.useState("rent");
    const defaultProperty = localStorage.getItem("propertyId");
    const [request, setRequest] = React.useState({
        chequeId: null,
        contractId: null,
        amount: selectedPdcData ? selectedPdcData.amount : "",
        date: dayjs(),
        bankRefNumber: "",
        transactionType: "",
        receiptType: "Rent",
        remarks: "",
        propertyId: defaultProperty || null,
        unitId: null,
        isReverse: false,
        depositType: "Normal",
        attachment: "",
        docName: "",
    });

    React.useEffect(() => {
        if (request.propertyId && request.unitId && !otherIncomeChecked) {
            fetchContract();
        }
    }, [request?.propertyId, request?.unitId]);

    React.useEffect(() => {
        fetchUnit(defaultProperty);
    }, []);

    React.useEffect(() => {
        if (editMode && editData) {
            setRequest((prevData) => ({
                ...prevData,
                chequeId: editData.chequeId,
                contractId: editData.contractId,
                amount: editData.amount || "",
                date: editData.date,
                bankRefNumber: editData.bankRefNumber,
                remarks: editData.remarks,
                propertyId: defaultProperty || null,
                unitId: editData.unitId,
                transactionType: editData.transactionType,
                receiptType: editData.receiptType,
                isReverse: editData.isReverse,
                depositType: editData.depositType,
                docName: editData?.docName || "",
                description: editData?.description || "",
            }));
            setSelectedPdcId(editData.chequeId);

            switch (editData.transactionType) {
                case "cash":
                    // setPdcType("rent");
                    setCashChecked(true);
                    setChequeChecked(false);
                    setBankTransferChecked(false);
                    break;
                case "cheque":
                    // setPdcType("rent");
                    setChequeChecked(true);
                    setCashChecked(false);
                    setBankTransferChecked(false);
                    break;
                case "Bank Transfer":
                    setBankTransferChecked(true);
                    setChequeChecked(false);
                    setCashChecked(false);
                    break;
                default:
                    setBankTransferChecked(false);
                    setCashChecked(false);
                    setChequeChecked(false);
                    break;
            }
            switch (editData.receiptType) {
                case "Other Income":
                    setOtherIncomeChecked(true);
                    setDeposit(false);
                    setRent(false);
                    break;
                case "Deposit":
                    setOtherIncomeChecked(false);
                    setDeposit(true);
                    setRent(false);
                    break;
                case "Rent":
                    setOtherIncomeChecked(false);
                    setDeposit(false);
                    setRent(true);
                    break;
                default:
                    setOtherIncomeChecked(false);
                    setDeposit(false);
                    setRent(false);
                    break;
            }
        }
    }, [editData, editMode]);
    const fetchUnit = async (id) => {
        const res = await getAllUnits(100, 0, "", id);
        setFlat(res.data);
    };

    React.useEffect(() => {
        const fetchPDC = async () => {
            if (request?.contractId) {
                const res = await getReceiptPdc(request?.contractId, pdcType);
                setData(res?.data);
            }
        };
        fetchPDC();
    }, [request?.contractId, pdcType]);

    const fetchContract = async () => {
        try {
            const res = await getContractByProperty({
                propertyId: request?.propertyId,
                unitId: request?.unitId,
            });
            if (!res.contract.length && !editMode) {
                setData([]);
                return toast.error("Contract details not found.");
            }
            setContractData(res.contract);
            setRequest((prevState) => ({
                ...prevState,
                contractId: res.contract[0]?.id,
            }));
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleCashChange = (event) => {
        const isChecked = event.target.checked;
        setCashChecked(isChecked);
        // setPdcType("rent");
        setRequest((prevState) => ({
            ...prevState,
            transactionType: "cash",
        }));
        if (isChecked) {
            setChequeChecked(false);
            setBankTransferChecked(false);
        }
    };

    const handleChequeChange = (event) => {
        const isChecked = event.target.checked;
        setChequeChecked(isChecked);
        // setPdcType("rent");
        setRequest((prevState) => ({
            ...prevState,
            transactionType: "cheque",
        }));
        if (isChecked) {
            setCashChecked(false);
            setBankTransferChecked(false);
        }
    };

    const handleBankTransferChange = (event) => {
        const isChecked = event.target.checked;
        setBankTransferChecked(isChecked);
        // setPdcType("rent");
        setRequest((prevState) => ({
            ...prevState,
            transactionType: "Bank Transfer",
        }));
        if (isChecked) {
            setCashChecked(false);
            setChequeChecked(false);
        }
    };
    const handleOtherIncomeChange = (event) => {
        const isChecked = event.target.checked;
        setOtherIncomeChecked(isChecked);
        setRequest((prevState) => ({
            ...prevState,
            receiptType: "Other Income",
        }));
        if (isChecked) {
            setDeposit(false);
            setRent(false);
        }
    };
    const handleDepositChange = (event) => {
        const isChecked = event.target.checked;
        setDeposit(isChecked);
        setPdcType("deposit");
        setRequest((prevState) => ({
            ...prevState,
            receiptType: "Deposit",
        }));
        if (isChecked) {
            setOtherIncomeChecked(false);
            setRent(false);
        }
    };
    const handleRentChange = (event) => {
        const isChecked = event.target.checked;
        setRent(isChecked);
        setPdcType("rent");
        setRequest((prevState) => ({
            ...prevState,
            receiptType: "Rent",
        }));
        if (isChecked) {
            setOtherIncomeChecked(false);
            setDeposit(false);
        }
    };

    const handleDocChange = (e) => {
        const file = e.target.files[0];
        setRequest((prevData) => ({
            ...prevData,
            attachment: file,
        }));
    };

    const handleSelectPdc = (pdc) => (event) => {
        const isChecked = event.target.checked;
        setSelectedPdcId(isChecked ? pdc.id : null);
        setSelectedPdcData(isChecked ? pdc : null);
        setRequest((prevValue) => ({
            ...prevValue,
            amount: isChecked ? pdc.amount : "",
            date: /*isChecked ? pdc.chequeDate : ""*/ dayjs(),
            contractId: isChecked ? pdc.contractId : "",
            chequeId: isChecked ? pdc.id : null,
            bankRefNumber: "",
            remarks: "",
        }));
    };
    const handlePropertyChange = (newValue) => {
        setRequest((prevData) => ({
            ...prevData,
            propertyId: newValue ? newValue.id : null,
            contractId: null,
        }));
        if (newValue !== null) {
            fetchUnit(newValue.id);
        }
        setFlat([]);
        setContractData([]);
    };
    const handleUnitChange = (newValue) => {
        if (newValue && editData?.unitId === newValue?.id) {
            setRequest((prevData) => ({
                ...prevData,
                chequeId: editData.chequeId,
                contractId: editData.contractId,
                amount: editData.amount,
                date: editData.date,
                bankRefNumber: editData.bankRefNumber,
                remarks: editData.remarks,
                propertyId: defaultProperty || null,
                unitId: editData.unitId,
                // transactionType: editData.transactionType,
                // receiptType: editData.receiptType,
                isReverse: editData.isReverse,
                depositType: editData?.depositType,
                docName: editData?.docName || "",
                description: editData?.description || "",
            }));
        } else {
            setRequest((prevData) => ({
                ...prevData,
                unitId: newValue ? newValue.id : null,
                contractId: null,
                chequeId: null,
                amount: "",
                date: dayjs(),
                bankRefNumber: "",
                remarks: "",
                isReverse: false,
                docName: "",
                description: "",
                // receiptType: "Rent",
                // depositType: "",
                // transactionType: "",
            }));
            setContractData([]);
        }
        setSelectedPdcData(null);
        if (newValue === null) {
            setData([]);
            // setSelectedPdcData(null);
        }
    };
    const handleContactChange = (newValue) => {
        setRequest((prevData) => ({
            ...prevData,
            contractId: newValue ? newValue.id : null,
        }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setRequest((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleDateChange = (date) => {
        const formattedDate = date && date.isValid() ? date.format("YYYY-MM-DD") : "";
        setRequest((prevData) => ({
            ...prevData,
            date: date ? formattedDate : "",
        }));
    };

    const handleSubmit = async () => {
        try {
            if (!request?.transactionType) {
                return toast.error("Please select transaction type");
            }
            if (!otherIncomeChecked && !deposit && !request?.contractId) {
                return toast.error("Please select contract");
            }
            if (request?.transactionType === "cheque" && !request.chequeId) {
                return toast.error("Please select cheque");
            }
            if (request?.amount === 0 || request?.amount === "") {
                return toast.error("Please enter amount");
            }
            if (editMode) {
                const response = await updateTransaction(editData.id, request);
                toast.success(response.message);
            } else {
                const response = await addTransaction(request);
                toast.success(response.message);
            }

            setSelectedPdcId(null);
            setSelectedPdcData(null);
            setRequest((prevData) => ({
                ...prevData,
                chequeId: null,
                contractId: "",
                amount: "",
                date: dayjs(),
                bankRefNumber: "",
                remarks: "",
                propertyId: defaultProperty || null,
                unitId: null,
                isReverse: false,
                transactionType: "",
                receiptType: "Rent",
                depositType: editData.depositType,
                docName: "",
                description: "",
            }));
            setData([]);
            setCashChecked(false);
            setChequeChecked(false);
            setBankTransferChecked(false);
            setOtherIncomeChecked(false);
            setDeposit(false);
            setRent(true);
            onClose();
            onSubmit();
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };
    const handleDialogClose = () => {
        setSelectedPdcId(null);
        setSelectedPdcData(null);
        setRequest({
            chequeId: null,
            contractId: "",
            amount: "",
            date: dayjs(),
            bankRefNumber: "",
            remarks: "",
            propertyId: defaultProperty || null,
            unitId: null,
            transactionType: "",
            receiptType: "Rent",
            isReverse: false,
            docName: "",
            description: "",
        });
        setCashChecked(false);
        setChequeChecked(false);
        setBankTransferChecked(false);
        setOtherIncomeChecked(false);
        setDeposit(false);
        setRent(true);
        setData([]);
        onClose();
    };
    return (
        <Dialog open={open} onClose={handleDialogClose} fullWidth maxWidth={"md"}>
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                Receipt
                <IconButton onClick={handleDialogClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} p={"5px"} alignItems="center">
                    {/* Second Row: Receipt Type */}
                    <Grid item xs={12} container direction="column">
                        {/* First Row: Receipt Type */}
                        <Grid item>
                            <strong style={{ display: "block", paddingBottom: 0 }}>
                                Receipt Type
                            </strong>
                        </Grid>

                        {/* Second Row: Radio Buttons */}
                        <Grid item container spacing={2} alignItems="center">
                            <Grid item>
                                <FormControlLabel
                                    value="rent"
                                    control={
                                        <Radio
                                            checked={rent}
                                            onChange={handleRentChange}
                                            color="primary"
                                        />
                                    }
                                    label="Rent"
                                />
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    value="deposit"
                                    control={
                                        <Radio
                                            checked={deposit}
                                            onChange={handleDepositChange}
                                            color="primary"
                                        />
                                    }
                                    label="Deposit"
                                />
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    value="otherIncome"
                                    control={
                                        <Radio
                                            checked={otherIncomeChecked}
                                            onChange={handleOtherIncomeChange}
                                            color="primary"
                                        />
                                    }
                                    label="Other Income"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    {deposit && (
                        <Grid item xs={4}>
                            <TextField
                                select
                                color="primary"
                                fullWidth
                                label="Select Deposit"
                                name="depositType"
                                defaultValue={request.depositType}
                                value={request.depositType}
                                onChange={handleChange}
                            >
                                <MenuItem value="Normal">Normal</MenuItem>
                                <MenuItem value="Hold">Hold</MenuItem>
                            </TextField>
                        </Grid>
                    )}

                    <Grid item xs={12} container direction="column">
                        {/* First Row: Transaction Type */}
                        <Grid item>
                            <strong style={{ display: "block", paddingBottom: 0 }}>
                                Transaction Type
                            </strong>
                        </Grid>

                        {/* Second Row: Radio Buttons */}
                        <Grid item container spacing={2} alignItems="center">
                            <Grid item>
                                <FormControlLabel
                                    value="cash"
                                    control={
                                        <Radio
                                            checked={cashChecked}
                                            onChange={handleCashChange}
                                            color="primary"
                                        />
                                    }
                                    label="Cash"
                                />
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    value="cheque"
                                    control={
                                        <Radio
                                            checked={chequeChecked}
                                            onChange={handleChequeChange}
                                            color="primary"
                                        />
                                    }
                                    label="Cheque"
                                />
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    value="bankTransfer"
                                    control={
                                        <Radio
                                            checked={bankTransferChecked}
                                            onChange={handleBankTransferChange}
                                            color="primary"
                                        />
                                    }
                                    label="Bank Transfer"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={3} p={"5px"} mb={"3px"} alignItems="center">
                    <Grid item xs={4}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={property}
                            getOptionLabel={(option) => option.propertyName}
                            value={
                                defaultProperty
                                    ? property.find((pro) => pro.id == defaultProperty) || null
                                    : null
                            }
                            onChange={(event, newValue) => handlePropertyChange(newValue)}
                            isOptionEqualToValue={(option, value) => option === value}
                            getOptionDisabled={(option) => option.id != defaultProperty}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.propertyName}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Property" />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={units}
                            getOptionLabel={(option) => option.unitNumber}
                            value={
                                request?.unitId
                                    ? units.find((unit) => unit.id === request?.unitId)
                                    : null
                            }
                            onChange={(event, newValue) => handleUnitChange(newValue)}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.unitNumber}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Unit" />
                            )}
                        />
                    </Grid>
                    {!otherIncomeChecked && (
                        <Grid item xs={4}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={contractData}
                                getOptionLabel={(option) => option?.tenant?.name}
                                value={
                                    request?.contractId
                                        ? contractData.find(
                                              (contract) => contract.id === request?.contractId
                                          )
                                        : null
                                }
                                onChange={(event, newValue) => handleContactChange(newValue)}
                                isOptionEqualToValue={(option, value) => option === value}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option?.tenant?.name}
                                    </li>
                                )}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth label="Select Contract" />
                                )}
                            />
                        </Grid>
                    )}
                </Grid>
                {!otherIncomeChecked && (
                    <TableContainer
                        sx={{ overflowX: "auto", marginBottom: theme.spacing(2), maxHeight: 900 }}
                    >
                        <Table
                            stickyHeader
                            aria-label="sticky table"
                            sx={{ backgroundColor: "#fff" }}
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        fontWeight="900"
                                        sx={{
                                            backgroundColor: "#eef1f6",
                                            color: "#1a2138",
                                        }}
                                    >
                                        Cheque Date
                                    </TableCell>
                                    <TableCell
                                        fontWeight="900"
                                        sx={{
                                            backgroundColor: "#eef1f6",
                                            color: "#1a2138",
                                        }}
                                    >
                                        Cheque Number
                                    </TableCell>

                                    <TableCell
                                        fontWeight="900"
                                        sx={{
                                            backgroundColor: "#eef1f6",
                                            color: "#1a2138",
                                        }}
                                    >
                                        Bank
                                    </TableCell>
                                    <TableCell
                                        fontWeight="900"
                                        sx={{
                                            backgroundColor: "#eef1f6",
                                            color: "#1a2138",
                                        }}
                                    >
                                        Amount
                                    </TableCell>
                                    <TableCell
                                        fontWeight="900"
                                        sx={{
                                            backgroundColor: "#eef1f6",
                                            color: "#1a2138",
                                        }}
                                    >
                                        Paid Amount
                                    </TableCell>
                                    <TableCell
                                        fontWeight="900"
                                        sx={{
                                            backgroundColor: "#eef1f6",
                                            color: "#1a2138",
                                        }}
                                    >
                                        Tenant
                                    </TableCell>
                                    <TableCell
                                        fontWeight="900"
                                        sx={{
                                            backgroundColor: "#eef1f6",
                                            color: "#1a2138",
                                        }}
                                    >
                                        Building
                                    </TableCell>
                                    <TableCell
                                        fontWeight="900"
                                        sx={{
                                            backgroundColor: "#eef1f6",
                                            color: "#1a2138",
                                        }}
                                    >
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.length ? (
                                    data.map((row, index) => (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                            <TableCell>
                                                {row.chequeDate
                                                    ? moment(row.chequeDate).format("DD/MM/YYYY")
                                                    : "-"}
                                            </TableCell>
                                            <TableCell>{row.chequeSerialNumber}</TableCell>
                                            <TableCell>{row.banks.name}</TableCell>
                                            <TableCell>{row.amount}</TableCell>
                                            <TableCell>
                                                {row.paidAmount ? row.paidAmount : 0}
                                            </TableCell>
                                            <TableCell>{contractData[0]?.tenant?.name}</TableCell>
                                            <TableCell>
                                                {contractData[0]?.unit?.unitNumber}
                                            </TableCell>
                                            <TableCell>
                                                <Checkbox
                                                    checked={selectedPdcId === row.id}
                                                    onChange={handleSelectPdc(row)}
                                                    color="primary"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell
                                            colSpan={7}
                                            sx={{
                                                textAlign: "center",
                                                fontWeight: "700",
                                                mb: "2px",
                                            }}
                                        >
                                            No data found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                {selectedPdcData && (
                    <>
                        <TableContainer
                            sx={{
                                overflowX: "auto",
                                marginBottom: theme.spacing(2),
                                maxHeight: 900,
                            }}
                        >
                            <Table
                                stickyHeader
                                aria-label="sticky table"
                                sx={{ backgroundColor: "#fff" }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Cheque Date
                                        </TableCell>
                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Cheque Number
                                        </TableCell>

                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Bank
                                        </TableCell>
                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Amount
                                        </TableCell>
                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Tenant
                                        </TableCell>
                                        <TableCell
                                            fontWeight="900"
                                            sx={{
                                                backgroundColor: "#eef1f6",
                                                color: "#1a2138",
                                            }}
                                        >
                                            Building
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow
                                        // hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={selectedPdcData.id}
                                    >
                                        <TableCell>
                                            {selectedPdcData.chequeDate
                                                ? moment(selectedPdcData.chequeDate).format(
                                                      "DD/MM/YYYY"
                                                  )
                                                : "-"}
                                        </TableCell>
                                        <TableCell>{selectedPdcData.chequeSerialNumber}</TableCell>
                                        <TableCell>{selectedPdcData.banks.name}</TableCell>
                                        <TableCell>{selectedPdcData.amount}</TableCell>
                                        <TableCell>{contractData[0]?.tenant?.name}</TableCell>
                                        <TableCell>{contractData[0]?.unit?.unitNumber}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}

                <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            color="primary"
                            label="Amount"
                            type="number"
                            name="amount"
                            value={request.amount}
                            InputLabelProps={{
                                sx: { marginBottom: 1 },
                            }}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} color="primary">
                            <DatePicker
                                label="Transaction date"
                                name="date"
                                value={request.date ? dayjs(request.date) : null}
                                onChange={handleDateChange}
                                disabled={!canEditDate}
                                format="DD/MM/YYYY"
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Bank Reference Number"
                            name="bankRefNumber"
                            type="number"
                            value={request?.bankRefNumber}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Remark"
                            variant="outlined"
                            multiline
                            fullWidth
                            color="primary"
                            rows={4}
                            value={request?.remarks}
                            name="remarks"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={5}>
                                <TextField
                                    fullWidth
                                    color="primary"
                                    label="Document Name"
                                    name="docName"
                                    value={request?.docName}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={5} margin={"auto"}>
                                <input
                                    type="file"
                                    accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    onChange={(e) => handleDocChange(e)}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    {editData && editMode && (
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={request.isReverse}
                                        onChange={(e) =>
                                            setRequest({
                                                ...request,
                                                isReverse: e.target.checked,
                                            })
                                        }
                                        name="isReverse"
                                        color="primary"
                                    />
                                }
                                label="Reverse"
                            />
                        </Grid>
                    )}
                </Grid>
                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "end",
                        padding: theme.spacing(2),
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary,
                            backgroundColor: theme.palette.primary[800],
                        }}
                    >
                        Save
                    </Button>
                    {/* <Button
                        variant="contained"
                        // onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Print
                    </Button> */}
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default AddReceipt;
